import {
  channelPartnerList,
  states,
  cities,
  channelPartnerDashboard,
  paymentApprovalRequestList,
} from "constants/channelPartner";
import { courseEnrollmentReport } from "constants/report";
import * as api from "../API/index";
import { authorizedUser } from "components/CommonComponents/CommonFunctions";

export const addChannelPartner = async (bodyData) => {
  try {
    const res = await api.add_channel_partner(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const getChannelPartnerList = async (dispatch, pageNum, filters) => {
  try {
    const res = await api.get_channel_partner_list(pageNum, filters);
    dispatch({ type: channelPartnerList, payload: res?.data });
  } catch (error) {
    dispatch({
      type: channelPartnerList,
      payload: error?.response?.data || error,
    });
    authorizedUser(error.response?.data);
  }
};

export const getChannelPartnerById = async (id) => {
  try {
    const res = await api.get_channel_partner_by_id(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const updateChannelPartnerById = async (id, bodyData) => {
  try {
    const res = await api.update_channel_partner_by_id(id, bodyData);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const getStates = async (dispatch) => {
  try {
    const res = await api.state_list();
    dispatch({ type: states, payload: res.data });
  } catch (error) {
    dispatch({ type: states, payload: error?.response?.data || error });
    authorizedUser(error.response?.data);
  }
};

export const getCities = async (dispatch, filtersJSON) => {
  try {
    const res = await api.city_list(filtersJSON);
    dispatch({ type: cities, payload: res.data });
  } catch (error) {
    dispatch({ type: cities, payload: error?.response?.data || error });
    authorizedUser(error?.response?.data);
  }
};

export const addCity = async (bodyData) => {
  try {
    const res = await api.add_city(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
}
//profile
export const getChannelPartnerProfileDetails  = async () => {
  try {
    const res = await api.get_channel_partner_profile_details();
   return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};
//update profile 
export const updateChannelPartnerProfileDetails = async (bodyData) => {
  try {
    const res = await api.update_channel_partner_profile_details(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};
//
export const getPaymentApprovalRequests = async (dispatch, pageNum, filterParams) => {
  try {
    const res = await api.get_payment_approval_request_list(pageNum, filterParams);
    dispatch({ type: paymentApprovalRequestList, payload: res.data });
  } catch (error) {
    authorizedUser(error?.response?.data);
    dispatch({
      type: paymentApprovalRequestList,
            payload: error?.response?.data ?? { message: error?.message },
    });
  }
};

export const getChannelPartnerDashboard = async (dispatch, pageNum = 1) => {
  try {
    const res = await api.get_channel_partner_dashboard_summary(pageNum);
    dispatch({ type: channelPartnerDashboard, payload: res?.data });
  } catch (error) {
    dispatch({
      type: channelPartnerDashboard,
      payload: error?.response?.data || error,
    });
    authorizedUser(error?.response?.data);
  }
};

export const getChannelPartnerCourseEnrollmentReport = async (
  dispatch,
  pageNum,
  filters,
) => {
  try {
    const res = await api.get_channel_partner_course_enrollment_report(
      pageNum,
      filters,
    );

    dispatch({
      type: courseEnrollmentReport,
      payload: res?.data,
    });
  } catch (error) {
    dispatch({
      type: courseEnrollmentReport,
      payload: error?.response?.data || error,
    });

    authorizedUser(error?.response?.data);
  }
};
